import React from 'react';
import {Box} from '@mui/material';
import {NAVY, TEXTE_SECONDAIRE} from '../../tokens.js';
import {carteSx, sousTitreSx} from './dashStyles.js';

// R6 : état de chargement (squelettes dans les mêmes cartes) et période sans donnée.

export const MAIN_SX = {maxWidth: 1376, width: '100%', mx: 'auto', p: '24px 32px 48px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: '24px'};

const barre = (largeur, hauteur, fond, rayon = '6px') => ({width: largeur, height: hauteur, backgroundColor: fond, borderRadius: rayon});

function CarteSquelette() {
    return (
        <Box sx={{...carteSx, height: 138, p: '18px 20px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <Box sx={barre(140, 10, '#F0F2F5')}/>
            <Box sx={barre(80, 34, '#E6EAEE', '999px')}/>
            <Box sx={barre(200, 10, '#F0F2F5')}/>
        </Box>
    );
}

function BlocSquelette({largeurTitre, colonnes}) {
    return (
        <Box sx={{...carteSx, height: 170, p: '16px 24px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: '14px'}}>
            <Box sx={barre(largeurTitre, 14, '#DDE2E8')}/>
            <Box sx={{display: 'grid', gridTemplateColumns: `repeat(${colonnes}, minmax(0, 1fr))`, gap: '24px'}}>
                {Array.from({length: colonnes}, (_, i) => <Box key={i} sx={barre('auto', 70, '#F0F2F5', '999px')}/>)}
            </Box>
        </Box>
    );
}

function BandeauSquelette({colonnes, avecBloc}) {
    return (
        <Box component="section" sx={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
            <Box sx={barre(120, 16, '#DDE2E8')}/>
            <Box sx={{display: 'grid', gridTemplateColumns: `repeat(${colonnes}, minmax(0, 1fr))`, gap: '16px'}}>
                {Array.from({length: colonnes}, (_, i) => <CarteSquelette key={i}/>)}
            </Box>
            {avecBloc && (
                <Box sx={{display: 'grid', gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)', gap: '24px'}}>
                    <BlocSquelette largeurTitre={220} colonnes={4}/>
                    <BlocSquelette largeurTitre={120} colonnes={2}/>
                </Box>
            )}
        </Box>
    );
}

/** Contenu de `main` pendant le chargement (Dashboard-Chargement.dc.html) : un squelette par bandeau (lot 9). */
export function DashChargement({collecte = false}) {
    return (
        <Box component="main" aria-busy="true" sx={{...MAIN_SX, gap: '28px'}}>
            <BandeauSquelette colonnes={5} avecBloc={false}/>
            <BandeauSquelette colonnes={4} avecBloc/>
            {collecte && <BandeauSquelette colonnes={4} avecBloc={false}/>}
        </Box>
    );
}

const BOUTON = {height: 36, p: '0 14px', borderRadius: '999px', font: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer'};

/** Remplace la partie campagne quand la période n'a aucun événement (Dashboard-Vide.dc.html). */
export function DashVide({periode, onVoirCampagne, onAutrePeriode}) {
    return (
        <Box component="section" aria-labelledby="empty-title" sx={{...carteSx, p: '48px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '12px'}}>
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#8A929C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="1.5"/><path d="M3 10h18"/><path d="M8 3v4M16 3v4"/><path d="M8 15h8"/></svg>
            <Box component="h2" id="empty-title" sx={{m: 0, fontSize: 18, fontWeight: 800, color: NAVY}}>Aucune intervention sur cette période</Box>
            <Box component="p" sx={{m: 0, maxWidth: 560, color: TEXTE_SECONDAIRE}}>
                Aucun lavage ni aucune inspection n'est enregistré sur {periode}. Les indicateurs de service fait, le bloc RSE et les répartitions s'afficheront dès le premier lavage ou la première inspection.
            </Box>
            <Box sx={{display: 'flex', gap: '12px', mt: '8px'}}>
                <Box component="button" type="button" onClick={onVoirCampagne} sx={{...BOUTON, border: `1px solid ${NAVY}`, backgroundColor: NAVY, color: '#FFFFFF'}}>Voir la campagne 2026</Box>
                <Box component="button" type="button" onClick={onAutrePeriode} sx={{...BOUTON, border: '1px solid #D5DAE1', backgroundColor: '#FFFFFF', color: '#2D333B'}}>Choisir une autre période</Box>
            </Box>
        </Box>
    );
}

/** Légende au-dessus des alertes quand la partie campagne est vide (texte de la maquette Vide). */
export function DashLegendeAlertes() {
    return <Box component="span" sx={sousTitreSx}>État du patrimoine à date, indépendant de la période choisie</Box>;
}
